const WebAdminRouter = [
    {
        path: '',
        redirect: 'index'
    },
    {
        path: 'index',
        meta: {
            title: '首页',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/index'),
    },
    {
        path: 'version',
        meta: {
            title: '版本更新',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/version'),
    },
    {
        path: 'feedback',
        meta: {
            title: '意见反馈',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/feedback'),
    },
    {
        path: 'apply/list',
        meta: {
            title: '项目列表',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/apply/list'),
    },
    {
        path: 'apply/add/:id',
        meta: {
            title: '项目申报',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/apply/add'),
    },
    {
        path: 'apply/review/:id',
        meta: {
            title: '项目申报审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/principal/page/apply/review'),
    },
    {
        path: 'project/apply',
        meta: {
            title: '项目列表',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/principal/page/project/list'),
    },
    {
        path: 'project/list',
        meta: {
            title: '项目列表',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/project/list'),
    },
    {
        path: 'project/add/:id/:menu',
        meta: {
            title: '添加项目',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/project/add'),
    },
    {
        path: 'project/report/:id/:title',
        meta: {
            title: '项目汇报',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/project/report'),
    },
    {
        path: 'project/post/:id/',
        meta: {
            title: '项目结项',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/project/post'),
    },
    {
        path: 'project/remind',
        meta: {
            title: '提醒',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/project/remind'),
    },
    {
        path: 'task/assignment/apply/:id/:title',
        meta: {
            title: '权重赋分',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/principal/page/task/assignment'),
    },
    {
        path: 'verifier',
        meta: {
            title: '审核人员管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/admin/page/verifier'),
    },
    {
        path: 'units',
        meta: {
            title: '单位管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/admin/page/units'),
    },
    {
        path: 'project/classify',
        meta: {
            title: '项目类别管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/admin/page/classify'),
    },
    {
        path: 'statistics',
        meta: {
            title: '数据统计',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/admin/page/statistics'),
    },
    {
        path: 'task/apply/:id/:title',
        meta: {
            title: '任务审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/principal/page/task/apply'),
    },
    {
        path: 'task/review/:id/:title',
        meta: {
            title: '任务评审',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/principal/page/task/review'),
    },
    {
        path: 'task/list/:id/:title',
        meta: {
            title: '项目任务分解',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/task/list'),
    },
    {
        path: 'task/assignment/:id/:title',
        meta: {
            title: '权重赋分',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/task/assignment'),
    },
    {
        path: 'task/mine',
        meta: {
            title: '我的任务',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/task/mine'),
    },
    {
        path: 'outcome/list',
        meta: {
            title: '项目成果汇总',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/project/outcome/outcome'),
    },
    {
        path: 'outcome/search',
        meta: {
            title: '项目成果汇总',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/staff/page/project/outcome/search'),
    },
]
export default WebAdminRouter